import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/terms")({
  head: () =>
    buildHead({
      title: "Terms & Conditions | LohaLink",
      description:
        "LohaLink Terms & Conditions covering escrow, KYC, AI analysis, and double-blind communication for B2B scrap metal trading.",
      canonical: "/terms",
      ogType: "article",
    }),
  component: lazyRouteComponent(() => import("@/pages/Terms")),
});
